
const API_TIMEOUT = import.meta.env.REACT_APP_SEARCH_API_TIMEOUT || 6000

export default function offlineOrTimeoutPromise() {
    return new Promise((_, reject) => {
        if (!window?.navigator?.onLine) {
            reject(new Error('Device is in offline mode from navigator'));
        }
        setTimeout(() => reject(new Error('Network timeout hit timeout limit')), API_TIMEOUT)
    });
}